import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

import moment from 'moment-timezone'

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(String(value)).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm:ss')
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).tz('America/Sao_Paulo').format('DD/MM/YYYY')
  }

  return value
})

Vue.filter('formatTime', function (value) {
  if (value) {
    return moment(String(value)).tz('America/Sao_Paulo').format('HH:mm:ss')
  }
})

Vue.filter('money', function (value, currencyCode) {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: currencyCode || 'BRL'
  })

  return isNaN(value) ? '-' : formatter.format(value)
})

Vue.filter('moneyNoDecimal', function (value, currencyCode) {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: currencyCode || 'BRL',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })

  return isNaN(value) ? '-' : formatter.format(value)
})

Vue.filter('decimal', function (value) {
  const formatter = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2
  })

  return isNaN(value) ? '-' : formatter.format(value)
})

Vue.filter('status', function (value) {
  return parseInt(value) === 1 ? 'Ativo' : 'Inativo'
})

Vue.filter('statusPlans', function (value) {
  return [
    {
      text: 'Ativo',
      value: 'ACTIVE'
    },
    {
      text: 'Inativo',
      value: 'INACTIVE'
    },
    {
      text: 'Oculto',
      value: 'HIDDEN'
    }
  ].find(i => i.value === value).text
})


Vue.filter('deviceType', function (value) {
  switch (value) {
    case 'ALL':
      return 'Todos'
  }

  return value[0].toUpperCase() + value.substring(1).toLowerCase()
})

// axios
import axios from './axios.js'

Vue.prototype.$http = axios

import api from './api.js'

Vue.prototype.$api = api

// API Calls
import './http/requests'

// mock
import './fake-db/index.js'

// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'

// Vuexy Admin Filters
import './filters/filters'

// Clipboard
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

// Tour
import VueTour from 'vue-tour'

Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')

// VeeValidate
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate)

// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: 'AIzaSyB4DDathvvwuwlwnUu7F4Sow3oU22y5T1Y',
    libraries: 'places' // This is required if you use the Auto complete plug-in
  }
})

// Vuejs - Vue wrapper for hammerjs
import {VueHammer} from 'vue2-hammer'

Vue.use(VueHammer)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
